<template>
<div class="upload-box">
    <img :src="getEntityByLanguage(item, 'image')" />
</div>

<div v-if="form.from_media_library_id && form.item_id == item.id" class="upload-box">
    <img :src="form.loaded_file_path">
</div>

<b class="text-white font-bold mb-1 mt-3 block">{{ getEntityByLanguage(item, 'title') }}</b>
<small class="block text-white mb-3">
    {{ getEntityByLanguage(item, 'description')}}
</small>

<div class="mt-3 mb-3">
    <button @click="makeEditable(item)" class="btn btn-sm btn-black">Edit</button>
</div>
</template>

<script>
export default {
	props: [
		'item',
		'form',
		'getEntityByLanguage',
		'makeEditable'
	],
}
</script>